import React from 'react';
import {useParams} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import {isSubscriptionProduct, sortProduct} from "../Label/LabelDetail";

export default function GroupSummary() {
    const [group, setGroup] = React.useState();
    let {groupId} = useParams();

    if (group === undefined) {
        fetch(process.env.REACT_APP_API_URL + "/group/" + groupId + "/summary", {
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("BEARER_TOKEN")
            }
        })
            .then(response => response.json())
            .then((response) => {
                setGroup(response)
            })
    }

    if (group === undefined) return "";

    const products = group.filter(p => !isSubscriptionProduct(p));
    const subscriptions = group.filter(isSubscriptionProduct);

    return (<>
        <Typography variant={'h3'}> Riassunto ordine </Typography>
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}
              style={{marginTop: 10}}>
            
            {products.filter(p => p.figure_product === 0 && p.japanese_product === 0 && p.card_game_product === 0 && p.event_product === 0 && p.fashion_product === 0 && p.protective_product === 0 && p.vintage_product === 0).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>🇮🇹</span> ITALIANI <span style={{padding: 10}}>🇮🇹</span></span>
            </Grid>}
            {
                products.filter(p => p.figure_product === 0 && p.japanese_product === 0 && p.card_game_product === 0 && p.event_product === 0 && p.fashion_product === 0 && p.protective_product === 0 && p.vintage_product === 0).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }
            {products.filter(p => p.japanese_product === 1).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>🇯🇵</span> GIAPPONESI <span style={{padding: 10}}>🇯🇵</span></span>
            </Grid>}

            {
                products.filter(p => p.japanese_product === 1).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }

            {products.filter(p => p.figure_product === 1).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>🗿</span> FIGURES <span style={{padding: 10}}>🗿</span></span>
            </Grid>}
            {
                products.filter(p => p.figure_product === 1).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }

            {products.filter(p => p.card_game_product === 1).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>🃏</span> CARD GAME <span style={{padding: 10}}>🃏</span></span>
            </Grid>}
            {
                products.filter(p => p.card_game_product === 1).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }

            {products.filter(p => p.event_product === 1).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>👾</span> EVENTI <span style={{padding: 10}}>👾</span></span>
            </Grid>}
            {
                products.filter(p => p.event_product === 1).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }

            {products.filter(p => p.fashion_product === 1).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>👕</span> ABBIGLIAMENTO <span style={{padding: 10}}>👕</span></span>
            </Grid>}
            {
                products.filter(p => p.fashion_product === 1).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }

            {products.filter(p => p.protective_product === 1).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>🛡</span> BUSTINE <span style={{padding: 10}}>🛡</span></span>
            </Grid>}
            {
                products.filter(p => p.protective_product === 1).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }
            {products.filter(p => p.vintage_product === 1).length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>🕰</span> VINTAGE <span style={{padding: 10}}>🕰</span></span>
            </Grid>}
            {
                products.filter(p => p.vintage_product === 1).sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }
            {subscriptions.length > 0 && <Grid item xs={12}>
                <span><span style={{padding: 10}}>📦</span> ABBONAMENTI <span style={{padding: 10}}>📦</span></span>
            </Grid>}
            {
                subscriptions.sort(sortProduct).map((product, i) =>
                    <>
                        <Grid item xs={7}
                              component={"a"}
                              href={"https://mangayo.it/" + product.product_image_url}
                              target={"_blank"}
                              rel="noreferrer"
                              style={{
                                  color: "black",
                                  textDecoration: "none",
                                  backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                                  textAlign: "left"
                              }}
                        >
                            {product.product_name}
                        </Grid>
                        <Grid item xs={2} style={{
                            backgroundColor: i % 2 === 0 ? "lightgray" : "white",
                            fontWeight: product.sum > 1 ? 900 : 400,
                            color: product.sum > 1 ? "red" : "black"
                        }}>
                            {product.sum}
                        </Grid>
                    </>
                )
            }

        </Grid>
    </>);


}
